import {GlobalSearchController} from 'common/report/model-resources/global-search-controller';
import {contextify} from 'common/util/react';

const context = contextify<GlobalSearchController>();

export const GlobalSearchControllerProvider = context.Provider;
export const GlobalSearchControllerConsumer = context.Consumer;
export const useGlobalSearchController = context.hook;
